module.exports = __webpack_public_path__ + "img/checked-circle.2ce96ebb.svg";